import { render, staticRenderFns } from "./RecoveriesPanels.vue?vue&type=template&id=01b6f64f&"
import script from "./RecoveriesPanels.vue?vue&type=script&lang=js&"
export * from "./RecoveriesPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports